document.addEventListener("teeinblue-event-component-injected", function () {
  const elementToMove = document.querySelector(
    "product-property.product-input-property.mb-25.d-block"
  );
  const insertAfterElement = document.querySelector("#teeFormInputs");
  if (elementToMove && insertAfterElement) {
    insertAfterElement.after(elementToMove);
  }

  const elementToMove2 = document.querySelector(
    ".bls__visitors.heading-color.mb-25"
  );
  const insertAfterElement2 = document.querySelector(
    ".tee-block.tee-product-price"
  );
  if (elementToMove2 && insertAfterElement2) {
    insertAfterElement2.after(elementToMove2);
  }
});

document.addEventListener("teeinblue-event-component-injected", function () {
  const elementToMove3 = document.querySelector(".bls__single-shortdes.mb-20");
  const insertAfterElement3 = document.querySelector(
    ".tee-block.tee-product-price"
  );
  if (elementToMove3 && insertAfterElement3) {
    insertAfterElement3.after(elementToMove3);
  }
});


function updateCartDrawer() {
  const cart = document.querySelector("cart-notification") || document.querySelector("cart-drawer");
  console.log(cart);
  if (!cart) return;

  fetch("/cart.json")
    .then((res) => res.json())
    .then((cartData) => {
      if (cartData.item_count !== undefined) {
        document.querySelectorAll(".cart-count").forEach((el) => {
          if (el.classList.contains("cart-count-drawer")) {
            el.innerHTML = `(${cartData.item_count})`;
          } else {
            el.innerHTML = cartData.item_count;
          }
        });

        const headerTotalPrice = document.querySelector("header-total-price");
        if (headerTotalPrice) {
          headerTotalPrice.updateTotal(cartData);
        }

        const cartFreeShip = document.querySelector("free-ship-progress-bar");
        if (cartFreeShip) {
          cartFreeShip.init(cartData.items_subtotal_price);
        }
      }

      return fetch(`${window.location.pathname}?sections=${cart.getSectionsToRender().map((s) => s.id).join(",")}`);
    })
    .then((res) => res.json())
    .then((parsedState) => {
      cart.getSectionsToRender().forEach((section) => {
        const elementToReplace = document.getElementById(section.id);
        const html = new DOMParser().parseFromString(parsedState[section.id],"text/html");

        if (elementToReplace) {
          elementToReplace.innerHTML =
            html.querySelector("#form-mini-cart").innerHTML;
        }

        const countdown = cart.querySelector(".cart-countdown-time");
        const htmlCountdown = html.querySelector(".cart-countdown-time");
        if (countdown && htmlCountdown) {
          countdown.innerHTML = htmlCountdown.innerHTML;
          cart.countdownTimer();
        }
      });

      cart.cartAction();
      cart.open();
      BlsLazyloadImg.init();
    })
    .catch((e) => console.error("Error updating cart drawer:", e));
}

document.addEventListener('teeinblue-event-after-cart-added', () => {
  updateCartDrawer();
})
